import React, { useState, useEffect, useCallback } from 'react';
import { getData, updateData } from '../../services/footerServices';
import { Button, Form } from 'react-bootstrap';
import Header from '../../components/Layout/Header';
import Footer from '../../components/Layout/Footer';
import Sidebar from '../../components/Layout/Sidebar';
import Spinner from '../../components/Spinner';
import { toast } from 'react-toastify';

const Footers = () => {
  const [form, setForm] = useState({ id: '', f_heading: '', f_address: '', email_heading_one: '', email_one: '', email_heading_two: '', email_two: '', email_heading_three: '', email_three_one: '', email_three_two: '', call_loc_one: '', call_number_one: '', authorization_policy: '', whatsapp: '', testimonialtype: '',live_chat_widget_code:''});

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  // Fetch data
  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const data = await getData();
      if (data && data.length > 0) {
        setForm(data[0]); // Assuming there's only one record to edit
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
    finally {
      setTimeout(() => {
      setLoading(false);
      }, 500);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  
  // Validate form data
    const validateForm = () => {
    const newErrors = {};
    if (!form.f_heading) newErrors.f_heading = "Footer Heading is required";
    if (!form.f_address) newErrors.f_address = "Footer Address is required";
    if (!form.email_heading_one) newErrors.email_heading_one = "Email Heading One is required";
    if (!form.email_one) newErrors.email_one = "Email One is required";
    if (!form.email_heading_two) newErrors.email_heading_two = "Email Heading Two is required";
    if (!form.email_two) newErrors.email_two = "Email Two is required";
    if (!form.email_heading_three) newErrors.email_heading_three = "Email Heading Three is required";
    if (!form.email_three_one) newErrors.email_three_one = "Email Three One is required";
    if (!form.email_three_two) newErrors.email_three_two = "Email Three Two is required";
    if (!form.call_loc_one) newErrors.call_loc_one = "Call Location One is required";
    if (!form.call_number_one) newErrors.call_number_one = "Call Number One is required";
    if (!form.authorization_policy) newErrors.authorization_policy = "Authorization Policy is required";
    if (!form.whatsapp) newErrors.whatsapp = "WhatsApp is required";
    if (!form.whatsapp || !/^\+\d{10,15}$/.test(form.whatsapp)) {
    newErrors.whatsapp = 'Please enter a valid WhatsApp number (e.g. +12147483647)';
    }
    if (!form.live_chat_widget_code) newErrors.live_chat_widget_code = "Live Chat Widget Code is required";
    if (!form.live_chat_widget_code || !/^[0-9a-f]{24}\/[0-9a-z]{8,12}$/i.test(form.live_chat_widget_code)) {
      newErrors.live_chat_widget_code = 'Please enter a valid Tawk.to widget code (e.g. 631c498854f06e12d893d8b5/1gcj7uft0)';
    }


    if (!form.testimonialtype) newErrors.testimonialtype = "Testimonial Type is required";
    setErrors((prev) => ({ ...prev, ...newErrors }));
    return Object.keys({ ...errors, ...newErrors }).every((key) => !errors[key] && !newErrors[key]);  
  }
  // Handle input change
  const handleChange = (e) => {
    try{
        const { name, value } = e.target;
          // Create a copy of the current form data
          let updatedData = { ...form };
          let updatedErrors = { ...errors };
          updatedData[name] = value;
          if (value) {
          updatedErrors[name] = ''; // Clear error if corrected
        }
        setForm(updatedData);
        setErrors(updatedErrors);
      }
      catch (error) {
      console.error("Error in handleChange:", error);
    }
  };

  // Handle form submission (update details)
  const handleSubmit = async (e) => {
     e.preventDefault();
    if (!validateForm()) {
        return
      }
    try {
      const result = await updateData(form);
      if (result.status === 200) {
      fetchData(); // Refresh data after update
      toast.success("Updated Successfully!", { position: 'top-right',autoClose: 3000});
      }
      else{
        toast.error(result.message ||"Failed to Added data. Please try again.", {position: 'top-right',autoClose: 3000});
      }
    } catch (error) {
      console.error('Error updating data:', error);
    }
  };

  return (
    <div className="d-flex">
      <Sidebar />
      <div className="main-content w-100">
        <Header />
        {loading ? (
          <div className="d-flex justify-content-center align-items-center w-100" style={{ minHeight: "300px" }}>
          <Spinner />
        </div>
      ) :(
        <div>
        <div className="container-fluid p-4">
          <div className="row">
            <div className="col-8">
              <p className='mb-3 fs-4'>Footer Details <b>/ Contact Details</b></p>
            </div>
            <div className="col-4 text-end">
              {/* <button className="btn btn-primary mb-3 form-label-custom" onClick={() => openModal('add')}>
                Add
              </button> */}
            </div>
          </div>
          <Form>
          <div className="row">
            <Form.Group className="col-md-6 mb-3">
              <Form.Label className='form-label-custom'>Address Header <small className = "text-danger" >*</small></Form.Label>
              <Form.Control
                type="text"
                name="f_heading"
                value={form.f_heading}
                onChange={handleChange}
                isInvalid = {!!errors.f_heading}
              />
              <Form.Control.Feedback type="invalid">{errors.f_heading}</Form.Control.Feedback> 
              
            </Form.Group>
            <Form.Group className="col-md-6 mb-3">
              <Form.Label className='form-label-custom'>Address Information <small className='text-danger'>*</small></Form.Label>
              <Form.Control
                type="text"
                name="f_address"
                value={form.f_address}
                onChange={handleChange}
                isInvalid = {!!errors.f_address}
              />
              <Form.Control.Feedback type="invalid">{errors.f_address}</Form.Control.Feedback> 

            </Form.Group>
            <Form.Group className="col-md-6 mb-3">
              <Form.Label className='form-label-custom'>Email Heading one</Form.Label>
              <Form.Control
                type="text"
                name="email_heading_one"
                value={form.email_heading_one}
                onChange={handleChange}
                isInvalid = {!!errors.email_heading_one}
              />
                <Form.Control.Feedback type="invalid">{errors.email_heading_one}</Form.Control.Feedback> 
              
            </Form.Group>
            <Form.Group className="col-md-6 mb-3">
              <Form.Label className='form-label-custom'>Email One <small className='text-danger'>*</small></Form.Label>
              <Form.Control
                type="text"
                name="email_one"
                value={form.email_one}
                onChange={handleChange}
                isInvalid = {!!errors.email_one}
              />
                <Form.Control.Feedback type="invalid">{errors.email_one}</Form.Control.Feedback>             
            </Form.Group>
            
            <Form.Group className="col-md-6 mb-3">
              <Form.Label className='form-label-custom'>Email heading two <small className='text-danger'>*</small></Form.Label>
              <Form.Control
                type="text"
                name="email_heading_two"
                value={form.email_heading_two}
                onChange={handleChange}
                isInvalid = {!!errors.email_heading_two}
              />
                <Form.Control.Feedback type="invalid">{errors.email_heading_two}</Form.Control.Feedback>             
              
            </Form.Group>
            <Form.Group className="col-md-6 mb-3">
              <Form.Label className='form-label-custom'>Email two <small className='text-danger'>*</small></Form.Label>
              <Form.Control
                type="text"
                name="email_two"
                value={form.email_two}
                onChange={handleChange}
                isInvalid = {!!errors.email_two}
              />
                <Form.Control.Feedback type="invalid">{errors.email_two}</Form.Control.Feedback>             
            </Form.Group>
            <Form.Group className="col-md-6 mb-3">
              <Form.Label className='form-label-custom'>Email heading three <small className='text-danger'>*</small></Form.Label>
              <Form.Control
                type="text"
                name="email_heading_three"
                value={form.email_heading_three}
                onChange={handleChange}
                isInvalid ={!!errors.email_heading_three}
              />
                <Form.Control.Feedback type="invalid">{errors.email_heading_three}</Form.Control.Feedback>             
            </Form.Group>
            <Form.Group className="col-md-6 mb-3">
              <Form.Label className='form-label-custom'>Email Three (1) <small className='text-danger'>*</small></Form.Label>
              <Form.Control
                type="text"
                name="email_three_one"
                value={form.email_three_one}
                onChange={handleChange}
                isInvalid ={!!errors.email_three_one}
              />
              <Form.Control.Feedback type="invalid">{errors.email_three_one}</Form.Control.Feedback>             


            </Form.Group>
            <Form.Group className="col-md-6 mb-3">
              <Form.Label className='form-label-custom'>Email Three (2) <small className='text-danger'>*</small></Form.Label>
              <Form.Control
                type="text"
                name="email_three_two"
                value={form.email_three_two}
                onChange={handleChange}
                isInvalid ={!!errors.email_three_two}
              />
                <Form.Control.Feedback type="invalid">{errors.email_three_two}</Form.Control.Feedback>             

            </Form.Group>

            <Form.Group className="col-md-6 mb-3">
              <Form.Label className='form-label-custom'>Call Location One <small className='text-danger'>*</small></Form.Label>
              <Form.Control
                type="text"
                name="call_loc_one"
                value={form.call_loc_one}
                onChange={handleChange}
                isInvalid ={!!errors.call_loc_one}
              />
              <Form.Control.Feedback type="invalid">{errors.call_loc_one}</Form.Control.Feedback>             

            </Form.Group>

            <Form.Group className="col-md-6 mb-3">
              <Form.Label className='form-label-custom'>Call Number One <small className='text-danger'>*</small></Form.Label>
              <Form.Control
                type="text"
                name="call_number_one"
                value={form.call_number_one}
                onChange={handleChange}
                isInvalid ={!!errors.call_number_one}
              />
              <Form.Control.Feedback type="invalid">{errors.call_number_one}</Form.Control.Feedback>             

            </Form.Group>
            <Form.Group className="col-md-6 mb-3">
              <Form.Label className='form-label-custom'>Whatsapp Number  <small className='text-danger'>*</small> <small className='text-primary form-label-note'>(Eg. +12147483647) </small></Form.Label>
              <Form.Control
                type="text"
                name="whatsapp"
                value={form.whatsapp}
                onChange={handleChange}
                isInvalid ={!!errors.whatsapp}
                 placeholder="+12147483647"
              />
              <Form.Control.Feedback type="invalid">{errors.whatsapp}</Form.Control.Feedback>             

            </Form.Group>
            <Form.Group className="col-md-6 mb-3">
              <Form.Label className='form-label-custom'>Live Chat Widget Code<small className='text-danger'>*</small> </Form.Label>
              <p><small className='text-primary form-label-note'>(Tawk.to Integration (e.g. 631c498854f06e12d893d8b5/1gcj7uft0)</small></p>
              <Form.Control
                type="text"
                name="live_chat_widget_code"
                value={form.live_chat_widget_code}
                onChange={handleChange}
                isInvalid ={!!errors.live_chat_widget_code}
                placeholder="Tawk.to Widget Code (e.g. 631c498854f06e12d893d8b5/1gcj7uft0)"
              />
              <Form.Control.Feedback type="invalid">{errors.live_chat_widget_code}</Form.Control.Feedback>             

            </Form.Group>
            </div>
            <Button variant="success" onClick={handleSubmit}>Submit</Button>          
          </Form>
        </div>
        <Footer />
         </div>
        )}
      </div>
    </div>
  );
};

export default Footers;
